import { useCallback, useEffect } from "react";
import { useCreateVisitorAccessDocTokenCallback } from "../waiting-room/useCreateVisitorAccessDocTokenMutation";
import { useVisitorId } from "../useVisitorId";
import { useParams } from "react-router-dom";
import { useAtomValue } from "jotai";
import { visitorNameAtom } from "../state";
import {
  ConnectionError,
  useInitTwilioSyncClient as useBaseInitTwilioSyncClient,
} from "../../session";
import {
  RETRYING_CONNECTION_INFO_TOAST_KEY,
  TERMINAL_CONNECTION_ERROR_TOAST_KEY,
} from "../../provider/sync";
import { toast } from "../../toasts";
import {
  RETRYING_CONNECTION_INFO_TEXT,
  TERMINAL_CONNECTION_ERROR_TEXT,
} from "./constants";
import { logger } from "../../datadog";

export function useInitTwilioSyncClient() {
  const [createTwilioVisitorAccessDocToken, { data }] =
    useCreateVisitorAccessDocTokenCallback();
  const visitorUuid = useVisitorId();
  const visitorName = useAtomValue(visitorNameAtom);
  const { providerShortId } = useParams() as { providerShortId: string };

  useEffect(
    function createAccessToken() {
      createTwilioVisitorAccessDocToken({
        visitorName,
        visitorUuid,
        providerShortId,
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  const onConnectionError = useCallback((error: ConnectionError) => {
    if (error.terminal) {
      toast.close(RETRYING_CONNECTION_INFO_TOAST_KEY);
      toast.error(TERMINAL_CONNECTION_ERROR_TEXT, {
        key: TERMINAL_CONNECTION_ERROR_TOAST_KEY,
        timeout: Infinity,
        purpose: "system",
      });
    } else {
      logger.info("Retrying twilio sync connection");
      toast.info(RETRYING_CONNECTION_INFO_TEXT, {
        key: RETRYING_CONNECTION_INFO_TOAST_KEY,
        timeout: Infinity,
        purpose: "system",
      });
    }
  }, []);

  useBaseInitTwilioSyncClient({
    jwt: data?.createTwilioVisitorAccess?.jwt,
    onConnectionError,
  });
}
